import _ from 'lodash';
import {v4 as uuid} from 'uuid';

const log = {
  namespaced: true,
  state: {
    logEntries: {
      byUser: [],
      rolls: [],
      oracles: [],
    },
  },

  getters: {
    logItems(state) {
      let items = [];
      items = items.concat(state.logEntries.rolls);
      items = items.concat(state.logEntries.byUser);
      items = items.concat(state.logEntries.oracles);
      return _.orderBy(items, ['createdAt'], ['desc']);
    },
  },

  mutations: {
    addUserEntry(state, entry) {
      state.logEntries.byUser.push(entry);
    },
    addRollEntry(state, entry) {
      state.logEntries.rolls.push(entry);
    },
    addOracleEntry(state, entry) {
      state.logEntries.oracles.push(entry);
    },
    deleteUserEntry(state, entry) {
      var index = state.logEntries.byUser.findIndex(e => e.uuid === entry.uuid);
      state.logEntries.byUser.splice(index, 1);
    },
    deleteRollEntry(state, entry) {
      var index = state.logEntries.rolls.findIndex(e => e.uuid === entry.uuid);
      state.logEntries.rolls.splice(index, 1);
    },
    deleteOracleEntry(state, entry) {
      var index = state.logEntries.oracles.findIndex(
        e => e.uuid === entry.uuid,
      );
      state.logEntries.oracles.splice(index, 1);
    },
  },

  actions: {
    initializeLog({commit, getters}) {
      if (getters.logItems.length === 0) {
        const entry = {
          uuid: uuid(),
          entryType: 'user',
          text: "This is the main log where move rolls, oracles and user-entered text shows up. You can delete this entry (or any other) by using the 'x' to the right",
          createdAt: new Date().getTime(),
        };
        commit('addUserEntry', entry);

        const moveEntry = {
          uuid: uuid(),
          entryType: 'move',
          statBonus: 1,
          statRolled: 'iron',
          result: {
            actionDie: 4,
            challenge1: 8,
            challenge2: 2,
            type: 'wh',
            text: 'Weak Hit',
            match: false,
          },
          createdAt: new Date().getTime(),
          moveTitle: "Example Move",
          moveResult: "When you get a weak hit in the example move, its time to start playing!",
        };
        commit('log/addRollEntry', moveEntry, { root: true })
      }
    },
    addUserEntry({commit}, payload) {
      const entry = {
        uuid: uuid(),
        entryType: 'user',
        text: payload.text,
        createdAt: new Date().getTime(),
      };
      commit('addUserEntry', entry);
    },
    deleteEntry({commit}, entry) {
      if (entry.entryType === 'user') {
        commit('deleteUserEntry', entry);
      } else if (
        entry.entryType === 'roll' ||
        entry.entryType === 'genericChallengeRoll' ||
        entry.entryType === 'move'
      ) {
        commit('deleteRollEntry', entry);
      } else if (entry.entryType === 'oracle') {
        commit('deleteOracleEntry', entry);
      } else {
        return;
      }
    },
  },
};

export default log;
